
import React from 'react';
import { Button } from '@/components/ui/button';
import { Compass, Loader2 } from 'lucide-react';
import { useOrientationEstimation } from '@/hooks/useOrientationEstimation';
import { 
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';

interface OrientationEstimationButtonProps {
  terraceId: string;
  onEstimationComplete?: () => void;
  size?: 'default' | 'sm' | 'lg' | 'icon';
}

const OrientationEstimationButton = ({ 
  terraceId, 
  onEstimationComplete,
  size = 'sm'
}: OrientationEstimationButtonProps) => {
  const { estimateOrientation, isEstimating } = useOrientationEstimation();

  const handleEstimate = async () => {
    const result = await estimateOrientation(terraceId);
    if (result && onEstimationComplete) {
      onEstimationComplete();
    }
  };

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            type="button"
            variant="outline"
            size={size}
            onClick={handleEstimate}
            disabled={isEstimating}
            className="flex items-center gap-2"
          >
            {isEstimating ? (
              <Loader2 className="h-4 w-4 animate-spin" />
            ) : (
              <Compass className="h-4 w-4" />
            )}
            {size !== 'icon' && (isEstimating ? 'Estimating...' : 'Estimate')}
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>Use AI to estimate terrace orientation from Street View images</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default OrientationEstimationButton;
